var impressum = "Impresszum";
var privacy = "Adatvédelem és jogi információk";
var recallInfo = "Visszahívási információk";
var signOut = "Kijelentkezés";
var hu_hu = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { hu_hu as default, impressum, privacy, recallInfo, signOut };
